// ============================================================================
// SwitchButton.jsx — Corelia UI v1.2
// SwitchButton aligné FormLayout + thème unifié (sans main.css)
// ============================================================================

import React from "react";
import theme from "../../../styles/theme";
import FormLayout from "./FormLayout";

const SwitchButton = ({
  label = "",
  required = false,

  labelPosition = "left", // "left" | "top"
  labelWidth = 120,
  align = "center",

  enabled = false,
  onChange,
  showText = true,
  size = "small",

  disabled = false,

  width = "100%",
  style = {},
  switchStyle = {},
  inputStyle = {},
}) => {
  const sizes = {
    small: { width: 24, height: 12, knob: 10 },
    medium: { width: 34, height: 18, knob: 14 },
  };
  const { width: w, height: h, knob } = sizes[size] || sizes.small;

  const isEnabled = !!enabled;

  const labelNode = (
    <>
      {label}
      {required && (
        <span style={{ color: theme.colors.text.required, marginLeft: 4 }}>*</span>
      )}
    </>
  );

  return (
    <FormLayout
      label={labelNode}
      labelPosition={labelPosition}
      labelWidth={labelWidth}
      align={align}
      width={width}
      style={style}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: theme.spacing.sm,
          width: "100%",
          opacity: disabled ? 0.6 : 1,
          pointerEvents: disabled ? "none" : "auto",
          ...inputStyle,
        }}
      >
        {/* Switch container */}
        <div
          onClick={() => onChange?.(!isEnabled)}
          style={{
            width: w,
            height: h,
            borderRadius: theme.borders.radius.full,
            backgroundColor: isEnabled ? theme.colors.states.enabled : theme.colors.states.disabled,
            position: "relative",
            cursor: disabled ? "not-allowed" : "pointer",
            transition: "background-color 0.2s ease",
            flexShrink: 0,
            ...switchStyle,
          }}
          role="switch"
          aria-checked={isEnabled}
          aria-disabled={disabled}
          tabIndex={disabled ? -1 : 0}
          onKeyDown={(e) => {
            if (disabled) return;
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              onChange?.(!isEnabled);
            }
          }}
        >
          {/* Knob */}
          <div
            style={{
              width: knob,
              height: knob,
              borderRadius: theme.borders.radius.full,
              backgroundColor: theme.colors.background.surface,
              position: "absolute",
              top: (h - knob) / 2,
              left: isEnabled ? w - knob - 2 : 2,
              transition: "left 0.2s ease",
              boxShadow: theme.shadows.sm,
            }}
          />
        </div>

        {/* Texte On/Off */}
        {showText && (
          <span
            style={{
              fontFamily: theme.form.field.fontFamily,
              fontSize: theme.fontSizes.sm,
              fontWeight: theme.fontWeights.medium,
              color: isEnabled ? theme.colors.states.enabled : theme.colors.states.disabled,
              userSelect: "none",
            }}
          >
            {isEnabled ? "On" : "Off"}
          </span>
        )}
      </div>
    </FormLayout>
  );
};

export default SwitchButton;